import { API, setAuthToken } from '../../../config/API.js';
import { GET_PORTFOLIO, SET_LOADING_PORTFOLIO, SET_PAGINATION_PORTFOLIO } from '../constant.js';

export const getPortfolio = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_PORTFOLIO,
      payload: true,
    });
    API.get(`admin/portfolio?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_PORTFOLIO,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_PORTFOLIO,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_PORTFOLIO,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_PORTFOLIO,
          payload: 0,
        });
      });
  };
};

export const addPortfolio = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/portfolio/add", params);
};

export const getDetailPortfolio = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/portfolio/${code}`);
};

export const updPortfolio = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/portfolio/edit", params);
};

export const delPortfolio = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/portfolio/delete/" + code);
};
